export type State = 'ACT' | 'NSW' | 'NT' | 'QLD' | 'SA' | 'VIC' | 'WA' | 'TAS';
export interface UnitType {
  label: string;
  value: string;
}

export const unitTypeOptions = [
  { label: 'Unit', value: 'U' },
  { label: 'Apartment', value: 'APT' },
  { label: 'Shop', value: 'SHOP' },
  { label: 'Factory', value: 'FY' },
  { label: 'Flat', value: 'F' },
  { label: 'Site', value: 'SITE' },
  { label: 'Stall', value: 'SL' },
  { label: 'Marine Berth', value: 'MB' },
  { label: 'Suite', value: 'SE' },
  { label: 'Studio', value: 'STU' },
  { label: 'Office', value: 'OFF' },
  { label: 'Room', value: 'RM' },
  { label: 'Shed', value: 'SHED' },
  { label: 'Ward', value: 'WARD' },
  { label: 'Warehouse', value: 'WE' },
  { label: 'Townhouse', value: 'TNHS' },
  { label: 'Kiosk', value: 'KSKU' },
];

export const stateOptions: { label: State; value: State }[] = [
  { label: 'ACT', value: 'ACT' },
  { label: 'NSW', value: 'NSW' },
  { label: 'NT', value: 'NT' },
  { label: 'QLD', value: 'QLD' },
  { label: 'SA', value: 'SA' },
  { label: 'VIC', value: 'VIC' },
  { label: 'WA', value: 'WA' },
  { label: 'TAS', value: 'TAS' },
];

export const streetTypeOptions = [
  { label: 'Access', value: 'ACCS' },
  { label: 'Alley', value: 'ALLY' },
  { label: 'Alleyway', value: 'ALWY' },
  { label: 'Amble', value: 'AMBL' },
  { label: 'Approach', value: 'APP' },
  { label: 'Anchorage', value: 'ANCG' },
  { label: 'Arcade', value: 'ARC' },
  { label: 'Artery', value: 'ART' },
  { label: 'Avenue', value: 'AVE' },
  { label: 'Basin', value: 'BASN' },
  { label: 'Beach', value: 'BCH' },
  { label: 'Bend', value: 'BEND' },
  { label: 'Block', value: 'BLK' },
  { label: 'Boulevard', value: 'BVD' },
  { label: 'Brace', value: 'BRCE' },
  { label: 'Brae', value: 'BRAE' },
  { label: 'Break', value: 'BRK' },
  { label: 'Bridge', value: 'BDGE' },
  { label: 'Broadway', value: 'BDWY' },
  { label: 'Brow', value: 'BROW' },
  { label: 'Bypass', value: 'BYPA' },
  { label: 'Byway', value: 'BYWY' },
  { label: 'Causeway', value: 'CAUS' },
  { label: 'Centre', value: 'CTR' },
  { label: 'Centreway', value: 'CNWY' },
  { label: 'Chase', value: 'CH' },
  { label: 'Circle', value: 'CIR' },
  { label: 'Circlet', value: 'CLT' },
  { label: 'Circuit', value: 'CCT' },
  { label: 'Circus', value: 'CRCS' },
  { label: 'Close', value: 'CL' },
  { label: 'Colonnade', value: 'CLDE' },
  { label: 'Common', value: 'CMMN' },
  { label: 'Concourse', value: 'CON' },
  { label: 'Copse', value: 'CPS' },
  { label: 'Corner', value: 'CNR' },
  { label: 'Corso', value: 'CSO' },
  { label: 'Court', value: 'CT' },
  { label: 'Courtyard', value: 'CTYD' },
  { label: 'Cove', value: 'COVE' },
  { label: 'Crescent', value: 'CRES' },
  { label: 'Crest', value: 'CRST' },
  { label: 'Cross', value: 'CRSS' },
  { label: 'Crossing', value: 'CRSG' },
  { label: 'Crossroad', value: 'CRD' },
  { label: 'Crossway', value: 'COWY' },
  { label: 'Cruiseway', value: 'CUWY' },
  { label: 'Cul-de-sac', value: 'CDS' },
  { label: 'Cutting', value: 'CTTG' },
  { label: 'Dale', value: 'DALE' },
  { label: 'Dell', value: 'DELL' },
  { label: 'Deviation', value: 'DEVN' },
  { label: 'Dip', value: 'DIP' },
  { label: 'Distributor', value: 'DSTR' },
  { label: 'Drive', value: 'DR' },
  { label: 'Driveway', value: 'DRWY' },
  { label: 'Edge', value: 'EDGE' },
  { label: 'Elbow', value: 'ELB' },
  { label: 'End', value: 'END' },
  { label: 'Entrance', value: 'ENT' },
  { label: 'Esplanade', value: 'ESP' },
  { label: 'Estate', value: 'EST' },
  { label: 'Expressway', value: 'EXP' },
  { label: 'Extension', value: 'EXTN' },
  { label: 'Fairway', value: 'FAWY' },
  { label: 'Fire Track', value: 'FTRK' },
  { label: 'Firetrail', value: 'FITR' },
  { label: 'Flat', value: 'FLAT' },
  { label: 'Follow', value: 'FOLW' },
  { label: 'Footway', value: 'FTWY' },
  { label: 'Foreshore', value: 'FSHR' },
  { label: 'Formation', value: 'FORM' },
  { label: 'Freeway', value: 'FWY' },
  { label: 'Front', value: 'FRNT' },
  { label: 'Frontage', value: 'FRTG' },
  { label: 'Gap', value: 'GAP' },
  { label: 'Garden', value: 'GDN' },
  { label: 'Gate', value: 'GTE' },
  { label: 'Gardens', value: 'GDNS' },
  { label: 'Gates', value: 'GTES' },
  { label: 'Glade', value: 'GLD' },
  { label: 'Glen', value: 'GLEN' },
  { label: 'Grange', value: 'GRA' },
  { label: 'Green', value: 'GRN' },
  { label: 'Ground', value: 'GRND' },
  { label: 'Grove', value: 'GR' },
  { label: 'Gully', value: 'GLY' },
  { label: 'Heights', value: 'HTS' },
  { label: 'Highroad', value: 'HRD' },
  { label: 'Highway', value: 'HWY' },
  { label: 'Hill', value: 'HILL' },
  { label: 'Interchange', value: 'INTG' },
  { label: 'Intersection', value: 'INTN' },
  { label: 'Junction', value: 'JNC' },
  { label: 'Key', value: 'KEY' },
  { label: 'Landing', value: 'LDG' },
  { label: 'Lane', value: 'LANE' },
  { label: 'Laneway', value: 'LNWY' },
  { label: 'Lees', value: 'LEES' },
  { label: 'Line', value: 'LINE' },
  { label: 'Link', value: 'LINK' },
  { label: 'Little', value: 'LT' },
  { label: 'Lookout', value: 'LKT' },
  { label: 'Loop', value: 'LOOP' },
  { label: 'Lower', value: 'LWR' },
  { label: 'Mall', value: 'MALL' },
  { label: 'Meander', value: 'MNDR' },
  { label: 'Mew', value: 'MEW' },
  { label: 'Mews', value: 'MEWS' },
  { label: 'Motorway', value: 'MWY' },
  { label: 'Mount', value: 'MT' },
  { label: 'Nook', value: 'NOOK' },
  { label: 'Outlook', value: 'OTLK' },
  { label: 'Parade', value: 'PDE' },
  { label: 'Park', value: 'PARK' },
  { label: 'Parklands', value: 'PKLD' },
  { label: 'Parkway', value: 'PKWY' },
  { label: 'Part', value: 'PART' },
  { label: 'Pass', value: 'PASS' },
  { label: 'Passage', value: 'PSGE' },
  { label: 'Path', value: 'PATH' },
  { label: 'Pathway', value: 'PHWY' },
  { label: 'Piazza', value: 'PIAZ' },
  { label: 'Place', value: 'PL' },
  { label: 'Plateau', value: 'PLAT' },
  { label: 'Plaza', value: 'PLZA' },
  { label: 'Pocket', value: 'PKT' },
  { label: 'Point', value: 'PNT' },
  { label: 'Port', value: 'PORT' },
  { label: 'Promenade', value: 'PROM' },
  { label: 'Quad', value: 'QUAD' },
  { label: 'Quadrangle', value: 'QDGL' },
  { label: 'Quadrant', value: 'QDRT' },
  { label: 'Quay', value: 'QY' },
  { label: 'Quays', value: 'QYS' },
  { label: 'Ramble', value: 'RMBL' },
  { label: 'Ramp', value: 'RAMP' },
  { label: 'Range', value: 'RNGE' },
  { label: 'Reach', value: 'RCH' },
  { label: 'Reserve', value: 'RES' },
  { label: 'Rest', value: 'REST' },
  { label: 'Retreat', value: 'RTT' },
  { label: 'Ride', value: 'RIDE' },
  { label: 'Ridge', value: 'RDGE' },
  { label: 'Ridgeway', value: 'RGWY' },
  { label: 'Right Of Way', value: 'ROWY' },
  { label: 'Ring', value: 'RING' },
  { label: 'Rise', value: 'RISE' },
  { label: 'River', value: 'RVR' },
  { label: 'Riverway', value: 'RVWY' },
  { label: 'Riviera', value: 'RVRA' },
  { label: 'Road', value: 'RD' },
  { label: 'Roads', value: 'RDS' },
  { label: 'Roadside', value: 'RDSD' },
  { label: 'Roadway', value: 'RDWY' },
  { label: 'Ronde', value: 'RNDE' },
  { label: 'Rosebowl', value: 'RSBL' },
  { label: 'Rotary', value: 'RTY' },
  { label: 'Round', value: 'RND' },
  { label: 'Route', value: 'RTE' },
  { label: 'Row', value: 'ROW' },
  { label: 'Rue', value: 'RUE' },
  { label: 'Run', value: 'RUN' },
  { label: 'Service Way', value: 'SWY' },
  { label: 'Siding', value: 'SDNG' },
  { label: 'Slope', value: 'SLPE' },
  { label: 'Sound', value: 'SND' },
  { label: 'Spur', value: 'SPUR' },
  { label: 'Square', value: 'SQ' },
  { label: 'Stairs', value: 'STRS' },
  { label: 'State Highway', value: 'SHWY' },
  { label: 'Steps', value: 'STPS' },
  { label: 'Strand', value: 'STRA' },
  { label: 'Street', value: 'ST' },
  { label: 'Strip', value: 'STRP' },
  { label: 'Subway', value: 'SBWY' },
  { label: 'Tarn', value: 'TARN' },
  { label: 'Terrace', value: 'TCE' },
  { label: 'Thoroughfare', value: 'THOR' },
  { label: 'Tollway', value: 'TLWY' },
  { label: 'Top', value: 'TOP' },
  { label: 'Tor', value: 'TOR' },
  { label: 'Towers', value: 'TWRS' },
  { label: 'Track', value: 'TRK' },
  { label: 'Trail', value: 'TRL' },
  { label: 'Trailer', value: 'TRLR' },
  { label: 'Triangle', value: 'TRI' },
  { label: 'Trunkway', value: 'TKWY' },
  { label: 'Turn', value: 'TURN' },
  { label: 'Underpass', value: 'UPAS' },
  { label: 'Upper', value: 'UPR' },
  { label: 'Vale', value: 'VALE' },
  { label: 'Viaduct', value: 'VDCT' },
  { label: 'View', value: 'VIEW' },
  { label: 'Villas', value: 'VLSS' },
  { label: 'Vista', value: 'VSTA' },
  { label: 'Wade', value: 'WADE' },
  { label: 'Walk', value: 'WALK' },
  { label: 'Walkway', value: 'WKY' },
  { label: 'Way', value: 'WAY' },
  { label: 'Wharf', value: 'WHRF' },
  { label: 'Wynd', value: 'WYND' },
  { label: 'Yard', value: 'YARD' },
];

export const streetTypeSuffixOptions = [
  { label: 'Central', value: 'CN' },
  { label: 'East', value: 'E' },
  { label: 'Extension', value: 'EX' },
  { label: 'Lower', value: 'LR' },
  { label: 'North', value: 'N' },
  { label: 'North East', value: 'NE' },
  { label: 'South', value: 'S' },
  { label: 'South East', value: 'SE' },
  { label: 'South West', value: 'SW' },
  { label: 'Upper', value: 'UP' },
  { label: 'West', value: 'W' },
];
